import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AuthLayoutProps } from './types';
import styles from './styles';

const theme = createTheme();
const AuthLayout = ({ component }: AuthLayoutProps) => {
    return (
        <ThemeProvider theme={theme}>
            <Grid container component="main">
                <CssBaseline />
                <Grid container sx={styles.image_container}>
                    <Grid item xs={false} sm={6} md={6} component={Paper} elevation={6} />
                    <Grid data-testid="sign_in_image" item xs={false} sm={6} md={6} sx={styles.signIn_bg_img} />
                </Grid>
                <Grid
                    container
                    item
                    component={Paper}
                    elevation={6}
                    sx={[styles.layout, styles.absolute]}
                    xs={12}
                    sm={6.7}
                    md={6.7}
                >
                    <Grid item xs={false} sm={8} md={8} sx={styles.logo_space}>
                        <div>
                            <Box
                                data-testid="diathrive_logo"
                                component="img"
                                sx={styles.logo}
                                alt="Diathrive Logo"
                                src="/images/logo.png"
                            />
                        </div>
                        <div>{component}</div>
                    </Grid>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};

export default AuthLayout;
